// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirmation-modal{max-width:400px}.confirmation-modal__description{white-space:pre-wrap;line-height:1.5}.confirmation-modal__wide{max-width:550px}`, "",{"version":3,"sources":["webpack://./src/modals/Confirmation/style.scss"],"names":[],"mappings":"AACA,oBACE,eAAA,CACA,iCACE,oBAAA,CACA,eAAA,CAEF,0BACE,eAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
